'use client';

import React, { useEffect, useState, type ReactNode } from 'react';

interface ObfuscatedEmailProps {
  email: string;
  className?: string;
  asLink?: boolean;
  linkClassName?: string;
  children?: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
}

export function ObfuscatedEmail({
  email,
  className,
  asLink = false,
  linkClassName,
  children,
  icon,
  onClick,
}: ObfuscatedEmailProps) {
  const [displayEmail, setDisplayEmail] = useState('');
  const [href, setHref] = useState('#');

  useEffect(() => {
    setDisplayEmail(email);
    if (asLink) {
      setHref(`mailto:${email}`);
    }
  }, [email, asLink]);

  if (!displayEmail) {
    // Render invisible placeholder of similar length to prevent layout shift
    return (
      <span className={className} style={{ opacity: 0 }} aria-hidden="true">
        {icon}
        {'\u200B'.repeat(email.length)}
      </span>
    );
  }

  if (asLink) {
    return (
      <a
        href={href}
        className={linkClassName || className}
        aria-label={typeof children === 'string' ? children : displayEmail}
        onClick={onClick}
      >
        {icon}
        {children ?? displayEmail}
      </a>
    );
  }

  return (
    <span className={className}>
      {icon}
      {children ?? displayEmail}
    </span>
  );
}
